<progress
  class="progress"
  [class.progress-primary]="color === 'primary'"
  [class.progress-secondary]="color === 'secondary'"
  [class.progress-accent]="color === 'accent'"
  [class.progress-info]="color === 'info'"
  [class.progress-success]="color === 'success'"
  [class.progress-warning]="color === 'warning'"
  [class.progress-error]="color === 'error'"
  [class.progress-xs]="size === 'xs'"
  [class.progress-sm]="size === 'sm'"
  [class.progress-lg]="size === 'lg'"
  [value]="percentage"
  [max]="100">
</progress>

